import { FC, useEffect } from 'react';
import { get, isNil, isEmpty } from 'lodash';
import { useHistory } from 'react-router';
import { Chip, Grid } from '@material-ui/core';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import { GridWrapper } from 'containers/PreOpeningPage/ClaimInformation/style';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Title,
  StyledCardContent,
  StyledCard,
  StyledChip,
} from 'containers/LawyerLegalProceedingsPage/styled-components';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import { ClaimRecapType } from 'typings/claimTypes';

export interface TopCardProps {
  claimRecap: ClaimRecapType;
  inputProps: any;
  intl: IntlShape;
  handleOpenCivilProceeding: Function;
  setDropDown: any;
  dropDown: any;
  claimNumber: string;
  sagisInfo: any;
  handleOpenFirmReferenceDialog: Function;
  requestSagisClaimInfo: Function;
  resetSagisInfoClaim: Function;
  displayActionButton: boolean;
}

export const TopCard: FC<TopCardProps> = props => {
  const { claimNumber } = props;
  const history = useHistory();

  useEffect(() => {
    if (!isEmpty(claimNumber)) {
      props.requestSagisClaimInfo(claimNumber);
    }
    history.listen(() => {
      props.resetSagisInfoClaim();
    });
  }, [claimNumber]);
  const dropDownMenuElements = [
    {
      title: translate(messages.civilProceeding, props),
      action: props.handleOpenCivilProceeding(2),
    },
    {
      title: translate(messages.commercialProceeding, props),
      action: props.handleOpenCivilProceeding(1),
    },
  ];
  return (
    <>
      <StyledCard>
        <StyledCardContent>
          <GridWrapper>
            <Grid container className="top-card">
              <Grid>
                <Grid
                  container
                  direction="row"
                  alignItems={'center'}
                  spacing={1}
                >
                  <Grid>
                    <Title gutterBottom>
                      {translate({ ...messages.claimNumber }, props) +
                        '   ' +
                        (isNil(props.claimNumber) ? '-' : props.claimNumber)}
                    </Title>
                  </Grid>
                  {!isNil(get(props.sagisInfo, 'status', null)) && (
                    <Grid>
                      <Chip
                        style={StyledChip}
                        className="primary"
                        label={get(props.sagisInfo, 'status', null)}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {props.displayActionButton && (
                <Grid item>
                  <DropDownDecisionMenu
                    setDropDown={props.setDropDown}
                    dropDown={props.dropDown}
                    label={translate(messages.managerActionTitle, props)}
                    menuElements={dropDownMenuElements}
                  />
                </Grid>
              )}
            </Grid>
          </GridWrapper>
        </StyledCardContent>
      </StyledCard>
    </>
  );
};

export default injectIntl(TopCard);
